import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@flightaware/ui-components';
import './TableHeader.scss';
import { capitalizeString } from 'utils/format';

interface TableHeaderProps {
    tableType: 'dashboard' | 'user';
    allowCreate: boolean;
}

const TableHeader: FC<TableHeaderProps> = (props) => {
    const navigate = useNavigate();
    const heading = capitalizeString(props.tableType) + 's';

    return (
        <div className="table-header" data-testid="table-header">
            <h1>{heading}</h1>
            {props.allowCreate && (
                <Button
                    handleClick={() => {
                        navigate(`/admin/${props.tableType}s/new`);
                    }}
                    size="medium"
                    variant="primary"
                >
                    Create new {props.tableType}
                </Button>
            )}
        </div>
    );
};

export default TableHeader;
